import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { combineLatest, map } from 'rxjs';

import { setCropYear } from '../../store/actions';
import {
  selectAvailableCropYears,
  selectCropYear,
  selectCurrentCropYear,
  selectIsCropYearReadOnly,
  selectIsCurrentCropYear,
} from '../../store/selectors';
import { SiteState } from '../models';

@Injectable({
  providedIn: 'root',
})
export class CropYearService {
  private readonly store = inject<Store<SiteState>>(Store);

  readonly cropYear = this.store.selectSignal(selectCropYear);
  readonly isCurrentCropYear = this.store.selectSignal(selectIsCurrentCropYear);
  readonly isReadOnly = this.store.selectSignal(selectIsCropYearReadOnly);

  readonly cropYear$ = this.store.select(selectCropYear);
  readonly availableCropYears$ = this.store.select(selectAvailableCropYears);
  readonly notice$ = combineLatest([this.cropYear$, this.store.select(selectCurrentCropYear)]).pipe(
    map(([cropYear, currentYear]) => (cropYear < currentYear ? { cropYear } : null)),
  );

  setCropYear(cropYear: number): void {
    this.store.dispatch(setCropYear({ cropYear }));
  }
}
